import { useLoaderData } from "react-router";
import SimpleFormPage from "../common/SimpleFormPage";
import AbsenceFields from "./AbsenceFields";

export default function EditAbsence() {
  const data = useLoaderData();
  const loadFn = (form) =>
    form.setFieldsValue({ ...data, employee: data.employee.id, type: data.type.id });
  return (
    <SimpleFormPage title="Modifica assenza" loadFn={loadFn}>
      <AbsenceFields employee={data.employee} />
    </SimpleFormPage>
  );
}
